// extracted by mini-css-extract-plugin
export default {"spinner":"Spinner__spinner____TQoS","spin":"Spinner__spin___pOx7n"};